var map = {
	"./Amit_parjapati.jpg": 201,
	"./Ashfaq_hussein.jpg": 855,
	"./Bharat_Giri.jpg": 583,
	"./Bibash_Dungana.png": 553,
	"./Jabbar_Ali.jpg": 216,
	"./Jatish_chaudahry.jpg": 280,
	"./Kushal_gautam.jpg": 179,
	"./Muarli.jpg": 733,
	"./Rohit_yadav.jpg": 197,
	"./Sailendra_yadav.jpg": 732,
	"./Sakcham_tripathi.jpg": 847
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 703;